var TokenKey = 'user_token'

export function setAdminToken (token) {
  return localStorage.setItem(TokenKey, token)
}

export function getAdminToken () {
  return localStorage.getItem(TokenKey)
}

export function removeAdminToken () {
  return localStorage.removeItem(TokenKey)
}



// WEBPACK FOOTER //
// ./src/utils/auth.js